var _rect, _rect2, _circle, _circle2, _path, _rect3, _circle3, _circle4, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 4,
    fill: "#EEF0FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 39,
    width: 39,
    height: 52,
    rx: 5,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1653,
    cy: 61.8101,
    r: 1.36698,
    fill: "#223BF4",
    stroke: "#223BF4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5442,
    cy: 56.1641,
    r: 1.36698,
    fill: "#223BF4",
    stroke: "#223BF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9595 61.4923C23.776 62.2912 25.3375 61.4923 25.8091 60.1125",
    stroke: "#223BF4",
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 63.5,
    width: 31,
    height: 28,
    rx: 5.5,
    fill: "#EEF0FE",
    stroke: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.5505,
    cy: 71.5503,
    r: 1.36698,
    transform: "rotate(30 38.5505 71.5503)",
    fill: "#223BF4",
    stroke: "#223BF4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.6922,
    cy: 74.3501,
    r: 1.36698,
    transform: "rotate(30 54.6922 74.3501)",
    fill: "#223BF4",
    stroke: "#223BF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5933 74.6722C45.7671 76.2723 47.5188 76.3612 48.6171 75.4021",
    stroke: "#223BF4",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyPlaceholder);
export default __webpack_public_path__ + "static/media/company-placeholder.6304b06ce4670b7ddf3d56f4ff2eae3b.svg";
export { ForwardRef as ReactComponent };